module.exports = __webpack_public_path__ + "img/dashboard-icon5.6f4b4d9a.svg";